import React, { useEffect, useRef } from 'react';

import { isEmpty } from '@utils/common';

import { Task } from '@interfaces/ganttTasks/ganttTasks';

import styles from './TaskList.module.scss';

export type TaskListProps = {
	headerHeight: number;
	rowHeight: number;
	ganttHeight: number;
	scrollY: number;
	tasks: Task[];
	isLoading: boolean;
	emptyText: string;
	taskListRef: React.RefObject<HTMLDivElement>;
	horizontalContainerClass?: string;
	onExpanderClick: (task: Task) => void;
	TaskListHeader: React.FC<{
		headerHeight: number;
	}>;
	TaskListTable: React.FC<{
		rowHeight: number;
		tasks: Task[];
		onExpanderClick: (task: Task) => void;
	}>;
};

const TaskList: React.FC<TaskListProps> = ({
	headerHeight,
	rowHeight,
	scrollY,
	tasks,
	onExpanderClick,
	ganttHeight,
	taskListRef,
	horizontalContainerClass,
	TaskListHeader,
	TaskListTable,
	isLoading,
	emptyText,
}) => {
	const horizontalContainerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (horizontalContainerRef.current) {
			horizontalContainerRef.current.scrollTop = scrollY;
		}
	}, [scrollY]);

	return (
		<div
			ref={taskListRef}
			style={{
				marginRight: '2px',
			}}
		>
			<TaskListHeader headerHeight={headerHeight} />
			<div
				ref={horizontalContainerRef}
				className={horizontalContainerClass}
				style={ganttHeight ? { height: ganttHeight } : {}}
			>
				<TaskListTable
					onExpanderClick={onExpanderClick}
					rowHeight={rowHeight}
					tasks={tasks}
				/>
			</div>
			{isEmpty(tasks) && !isLoading && <div className={styles.emptyText}>{emptyText}</div>}
		</div>
	);
};

export default TaskList;
